import { CheckoutPlan } from "../Onboarding";

export class MockCheckoutPlan implements CheckoutPlan {
  uuid: string;
  sku: string;
  formattedPrice = "19$";
  billingPeriod: "monthly" = "monthly";
  publicId: string;
  title?: string | undefined;
  description?: string | undefined;
  private static INDEX = 0;

  constructor(publicId?: string) {
    MockCheckoutPlan.INDEX++;
    this.sku = `id-${MockCheckoutPlan.INDEX}`;
    this.uuid = `uuid-${MockCheckoutPlan.INDEX}`;
    this.publicId = publicId || `public-${MockCheckoutPlan.INDEX}`;
  }
}
